/**
 * CRT Overlay Effect Component
 * Adds scanline effect over the entire application
 */
function CRTOverlay() {
  return <div className="crt-overlay" />
}

export default CRTOverlay
